// Z-index hierarchy for sticky positioning
export const Z_INDEX = {
  topLeft: 15, // the corner cell (highest)
  yAxis: 13, // sticky left column (labels)
  xAxis: 14, // sticky top headers and summary footer (horizontal)
  body: 1, // normal cells
} as const;
